module.exports = __webpack_public_path__ + "static/img/yellow-ballon.7067e9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/yellow-ballon.jpg
// module id = UpxR
// module chunks = 0